module.exports = {"height":1200,"width":2400,"type":"jpg"}